export class ListItem {
  id: number = 0;
  text: string = '';
}
